module.exports = __webpack_public_path__ + "img/people8.9b05783e.png";